import { Buffer } from "buffer";   // 👈 ADD THIS FIRST

if (!window.Buffer) {
  window.Buffer = Buffer;
}

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import "assets/css/material-dashboard-react.css?v=1.10.0";
import App from "./App";
import "../src/assets/fonts/poppins/poppins.css";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

import { createRoot } from "react-dom/client";

let persistor = persistStore(store);
const strictMode = process.env.NODE_ENV === "production";
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  (strictMode && (
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </React.StrictMode>
  )) || (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  )
);
